import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import {
  FilterItemNoResults,
  FiltersMenu,
  FiltersSubMenu,
} from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconPlace from '@/icons/Place.svg';

import { useFilters } from '../FiltersState';
import { useSubLocationOptions } from '../utils';

export const FiltersSubLocation = ({ tag }: { tag?: boolean }) => {
  const { t } = useLingui();

  const {
    subLocations: { subLocations, setSubLocations },
  } = useFilters();

  const subLocationOptions = useSubLocationOptions();
  const subLocationIds = subLocations.map((subLocation) => subLocation.id);

  const options =
    subLocationOptions.length > 0 ? (
      subLocationOptions.map((option) => (
        <FilterCheckboxItem
          key={option.id}
          checked={subLocationIds.includes(option.id)}
          onChange={(checked) => {
            if (checked) {
              setSubLocations([...subLocations, option]);
            } else {
              setSubLocations(subLocations.filter(({ id }) => option.id !== id));
            }
          }}
        >
          {option.label}
        </FilterCheckboxItem>
      ))
    ) : (
      <FilterItemNoResults />
    );

  if (tag) {
    if (subLocations.length === 0) {
      return null;
    }

    const numberOfSubLocations = subLocations.length;

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({ id: 'requests.filters.sub-location.label', message: 'Sub-location' })}
            value={
              subLocations.length === 1 ? (
                subLocations[0].label
              ) : (
                <Trans id="requests.filters.sub-location.multiple">
                  {numberOfSubLocations} sub-locations
                </Trans>
              )
            }
            tooltip={
              subLocations.length > 1
                ? subLocations.map((option) => option.label).join(', ')
                : undefined
            }
            onClear={() => setSubLocations([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconPlace />}
      label={t({ id: 'requests.filters.sub-location.label', message: 'Sub-location' })}
    >
      {options}
    </FiltersSubMenu>
  );
};
